var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Menu, MenuButton, MenuItem, MenuItems, Transition } from '@headlessui/react';
import { ClipboardIcon, DocumentArrowDownIcon } from '@heroicons/react/24/outline';
import { ArrowDownTrayIcon } from '@heroicons/react/24/solid';
import { useToast } from '@web/hocs/useToast';
import { copyToClipboard, createFileName, createFilenameFromFilters, saveAsCSV } from '@web/utility/exportUtils';
import { useFilters } from '@web/utility/hooks/useFilters';
import { json2csv } from 'json-2-csv';
import { Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';
export var ExportMenu = function (_a) {
    var onExportHandler = _a.onExportHandler, fileName = _a.fileName, disabled = _a.disabled;
    var t = useTranslation().t;
    var toast = useToast().toast;
    var filters = useFilters();
    var _b = useState(false), isLoading = _b[0], setIsLoading = _b[1];
    var prefix = createFilenameFromFilters(filters);
    var displayedFileName = "".concat(prefix ? "".concat(prefix, "-") : '').concat(createFileName(fileName));
    var showSuccessCopyToast = function () {
        toast({
            title: t('alert.success'),
            description: t('export.copiedToClipboard'),
            variant: 'success',
            duration: 3000
        });
    };
    var showSuccessExportToast = function () {
        toast({
            title: t('alert.success'),
            description: t('export.successfullyExported'),
            variant: 'success',
            duration: 3000
        });
    };
    var handleExport = function (type) { return __awaiter(void 0, void 0, void 0, function () {
        var data, rows, copied, text, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (isLoading || disabled)
                        return [2 /*return*/];
                    setIsLoading(true);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 5, 6, 7]);
                    return [4 /*yield*/, onExportHandler()];
                case 2:
                    data = _b.sent();
                    rows = (data !== null && data !== void 0 ? data : []);
                    if (!(type === 'clipboard')) return [3 /*break*/, 4];
                    return [4 /*yield*/, copyToClipboard(rows)];
                case 3:
                    copied = _b.sent();
                    if (!copied)
                        return [2 /*return*/];
                    showSuccessCopyToast();
                    return [2 /*return*/];
                case 4:
                    text = json2csv(rows);
                    if (!(text === null || text === void 0 ? void 0 : text.trim()))
                        return [2 /*return*/];
                    saveAsCSV(text, displayedFileName);
                    showSuccessExportToast();
                    return [3 /*break*/, 7];
                case 5:
                    _a = _b.sent();
                    toast({
                        title: t('alert.error'),
                        description: t('export.failed'),
                        variant: 'error',
                        duration: 3000
                    });
                    return [3 /*break*/, 7];
                case 6:
                    setIsLoading(false);
                    return [7 /*endfinally*/];
                case 7: return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs(Menu, __assign({ as: "div", className: "relative inline-block text-left" }, { children: [_jsx("div", { children: _jsx(MenuButton, __assign({ disabled: disabled || isLoading, className: "inline-flex justify-center items-center h-7 w-7 rounded-[4px] border border-gray-300 bg-white p-[2px] text-gray-700 shadow-sm hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed" }, { children: _jsx(ArrowDownTrayIcon, { className: "h-5 w-5", "aria-hidden": "true" }) })) }), _jsx(Transition, __assign({ as: Fragment, enter: "transition ease-out duration-100", enterFrom: "transform opacity-0 scale-95", enterTo: "transform opacity-100 scale-100", leave: "transition ease-in duration-75", leaveFrom: "transform opacity-100 scale-100", leaveTo: "transform opacity-0 scale-95" }, { children: _jsx(MenuItems, __assign({ className: "absolute right-0 z-10 mt-2 w-44 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none" }, { children: _jsxs("div", __assign({ className: "py-1" }, { children: [_jsx(MenuItem, { children: function (_a) {
                                    var focus = _a.focus;
                                    return (_jsxs("button", __assign({ type: "button", onClick: function () { return handleExport('csv'); }, className: "".concat(focus ? 'bg-gray-100' : '', " flex w-full items-center px-3 py-2 text-sm text-gray-700") }, { children: [_jsx(DocumentArrowDownIcon, { className: "mr-2 h-4 w-4" }), t('export.exportCSV')] })));
                                } }), _jsx(MenuItem, { children: function (_a) {
                                    var focus = _a.focus;
                                    return (_jsxs("button", __assign({ type: "button", onClick: function () { return handleExport('clipboard'); }, className: "".concat(focus ? 'bg-gray-100' : '', " flex w-full items-center px-3 py-2 text-sm text-gray-700") }, { children: [_jsx(ClipboardIcon, { className: "mr-2 h-4 w-4" }), t('export.copyToClipboard')] })));
                                } })] })) })) }))] })));
};
